<template
  ><span>
    {{ getStatus }}
  </span>
</template>
<script>
export default {
  computed: {
    getStatus: function() {
      let totalVotes;
      let percentage = 0;
      let onlineCount = this.$store.state.onlineUsers.length;
      let onlineProxies = this.$store.state.onlineUsers.reduce(
        (total, item) => total + item.weightedProxy,
        0
      );
      // check if we are ignoring proxies
      if (this.$store.state.polls.activePoll.ignoreProxy) {
        totalVotes = onlineCount;
      } else totalVotes = onlineCount + onlineProxies;

      let onlineVoted = this.$store.state.onlineUsers.filter(
        (user) => user.voted === true
      ).length;
      //console.log(onlineCount / onlineVoted);
      if (onlineVoted > 0)
        percentage = Math.round((onlineVoted / onlineCount) * 100);
      return `${onlineVoted} of ${onlineCount} (${percentage}%) voted | online ballots: ${totalVotes}`;
    }
  }
};
</script>
